import React from 'react';
import Header from '../components/Header';
import History from '../components/History';
import Footer from '../components/Footer';

const HistoryPage = () => {
  return (
    <div className="App">
      <Header />
      <main><History /></main>
      <Footer />
    </div>
  );
};

export default HistoryPage;
